import { PropsWithChildren } from 'react'

import { useCreation } from 'ahooks'

import { CustomMemberGroupStoreContext } from './contexts/StoreContext'
import { createCustomMemberGroupStore } from './store'
import { CustomMemberGroupOptions } from './store/interface'
import { CustomMemberGroupStoreUpdater } from './StoreUpdater'

export const CustomMemberGroupStoreProvider = ({
  disabled,
  value,
  onChange,
  children
}: PropsWithChildren<CustomMemberGroupOptions>) => {
  const store = useCreation(() => createCustomMemberGroupStore(), [])

  return (
    <CustomMemberGroupStoreContext value={store}>
      <CustomMemberGroupStoreUpdater
        disabled={disabled}
        value={value}
        onChange={onChange}
      />
      {children}
    </CustomMemberGroupStoreContext>
  )
}
